const initialValues = {
  name: "",
  email: "",
  phone: "",
  region: "",
  occupation: "",
  project_name: "",
  obstacle: "",
  experience: "",
  expectation: "",
  legal_terms_accepted: false,
};

export default initialValues;
